import { doccenHTTPRequest } from '../services/axios/httpRequest';

export const cancelFollow = async (userId: string) => {
  return doccenHTTPRequest.post('/follow/cancel', { cancelUserId: userId });
};

export const unFollow = (userId: string) => {
  return doccenHTTPRequest.post('/follow/unfollow', { unfollowUserId: userId });
};

export const removeFollow = (userId: string) => {
  return doccenHTTPRequest.post('/follow/remove', { removedUserId: userId });
};
